/* eslint-disable camelcase */
import { useMemo } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

const TDPIndex = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  const basename = `/${window.location.pathname.split("/").slice(1, 3).join("/")}`;
  return (
    <Provider store={store}>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </Provider>
  );
};

export default TDPIndex;
